module.exports = __webpack_public_path__ + "static/media/quotation-mark-icon.c7e635b1.svg";